import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResetPasswordModal from '../components/ResetPasswordModal';
import Layout from '../layouts/Layout';

const ResetPassword = () => {
    const navigate = useNavigate();

    return (
        <Layout>
            <ResetPasswordModal onClose={() => navigate('/login')} />
        </Layout>
    );
};

export default ResetPassword;
